import "./styles.css";
export const DashLayoutPerformance = (props) => {
  return (
    <div className="container-dash-perf">
      <div className="container-login-dash-perf">
        <div className="wrap-login-dash-perf">{props.children}</div>
      </div>
    </div>
  );
};
